
import './projects.css'
import Back from "../../common/Back"
import img from "../../images/about.jpg"

import Header from '../../common/header/Header'


import Recent from './recent/Recent'

const Projects = () => {
  return (
    <>
    <Header/>
    <Back cover={img} />


    <Recent title={'OnGoing Projects'}/>
        
    
    </>
  )
}

export default Projects